"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SHIMMER_BUTTON = void 0;

var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaMove/theme"));

var DEFAULT_SHIMMER_BUTTON = {
  WIDTH: '124px',
  HEIGHT: '48px',
  SHIMMER_COLOR: '#59E659',
  BORDER_RADIUS: _theme.default.borderRadius.XXnormal,
  BUTTON_TEXT_TOP: 'Combo Savings',
  BUTTON_TEXT_BOTTOM: 'MYR 10',
  BUTTON_COLOR: '#157B3E',
  HANDLE_MOUSE_ENTER: function HANDLE_MOUSE_ENTER() {},
  HANDLE_MOUSE_LEAVE: function HANDLE_MOUSE_LEAVE() {},
  CUSTOM_PROPERTIES: {
    size: '12px'
  },
  IS_SHOW_ICON: false
};
exports.DEFAULT_SHIMMER_BUTTON = DEFAULT_SHIMMER_BUTTON;